
import Vue from "vue";
import PlaceCardsWrapper from "./place-cards-wrapper.vue";
import VLogo from "./v-logo.vue";
export default Vue.extend({
  name: "sp",
  components: {
    PlaceCardsWrapper,
    VLogo,
  },
  data() {
      return {
          currentLanguage: "ja",
          logInterval: -1,
          scaleValue: 1,
          modal: true,
          //scaledStyle:"transform:scale(0.5)",
      };
  },
  props: ["floorPlan","placeIdHashList","vacancy","gender","monitorProps","monitorIdHash"],
  computed: {
      // 動的にスケールを計算
      /*
      scaledStyle() {
        //return {transform: "scale(" + this.scaleValue+")"}
        return "transform:scale("+ this.scaleValue +")"
      },
      */
  },
  methods: {
      scrollToCenter() {
          const body = this.$el.querySelector(".body") as HTMLElement;
          const center = this.$el.querySelector(".center") as HTMLElement;

          if (center) {
              body.scrollTo({
                left: center.offsetLeft / 4,
                behavior: "auto",
              });
          } else {
              console.error("mapが見つかりません");
          }
      },
      updateScale() {
          const baseWidth = 1920; // 基準幅
          const currentWidth = window.innerWidth;

          // 最小スケール値を0.9、最大スケール値を1.4に設定
          //this.scaleValue = Math.max(0.9, Math.min(currentWidth / baseWidth, 1.4));
          this.scaleValue = 540 / 1920;
          //this.scaleValue = 0.2;
          //this.scaledStyle = "transform:scale("+ this.scaleValue +")";
      },
  },
  mounted() {
      // ページリロード時にスクロール位置を保持しないように設定
      if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
      }
      // コンポーネントがマウントされた後にスクロール位置を調整
      this.scrollToCenter();
      // 最初に画面サイズを取得してスケール値を計算
      this.updateScale();
      // 画面幅が変更されてもスケール値を再計算（iphoneの場合不具合があるためコメントアウト）
      // window.addEventListener("resize", this.updateScale);
  },
});
